<template>
  <div  >
    <Header></Header>
    <Title title="人员统计>考试记录"></Title>
    <div class="contain_main">
      <!-- <div class="search">
        <div class="search_item">
          <div class="item">
            <span>员工姓名:</span>
            <Input v-model="value" placeholder="请输入..." style="width:2rem"/>
          </div>
          <div class="item">
            <span>员工ID:</span>
            <Input v-model="value" placeholder="请输入..." style="width:2rem"/>
          </div>

          <div class="item">
            <span>所属部门:</span>
            <Select v-model="model1" style="width:1rem">
              <Option value="1">xxx部门</Option>
              <Option value="2">xxx部门</Option>
              <Option value="3">xxx部门</Option>
            </Select>
          </div>
          <div class="item">
            <div class="button">搜索</div>
          </div>
        </div>
      </div>-->
      <div class="table">
        <table>
          <thead>
            <tr>
              <td>考试编号</td>
              <td>姓名</td>
              <td>考试名称</td>
              <!-- <td>正确率</td> -->
              <td>考试得分</td>
              <td>及格状态</td>
              <td>开始时间</td>
              <td>阅卷状态</td>
              <td>操作</td>
            </tr>
          </thead>
          <!-- ehendtime	number	true	提交时间
          ehispass	string	true	0不及格1及格null未评分
          ehscore	string	true	分数
          examtitle	string	true	考试标题
          ehtype	string	true	试卷类型
          ehusername	string	true	用户名
          ehuserid	number	true	用户id
          ehid	number	true	考试记录id-->
          <tbody>
            <tr v-for="(item,index) in list" :key="index">
              <td>{{item.ehid}}</td>
              <td>{{item.ehusername}}</td>
              <td>
                <Tooltip :content="item.examtitle" placement="top-start">
                  <span class="tableName">{{item.examtitle}}</span>
                </Tooltip>
              </td>
              <!-- <td>85%</td> -->
              <td>{{item.ehscore}}</td>
              <td>{{item.ehispass|jige}}</td>
              <td>{{item.ehendtime|formate}}</td>
              <td>{{item.ehdecide|yuejuan}}</td>
              <td>
                <button class="pri" @click="topaper(item.ehid,item.ehdecide)">查看解析</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="page" style="text-align:right;margin-top:20px;">
        <Page
          :total="total"
          :current='data.page'
          @on-change="changepage"
          @on-page-size-change="changesize"
          show-sizer
          show-elevator
          show-total
          :page-size-opts="[5,10, 20,50]"
        />
      </div>
    </div>
    <div></div>
  </div>
</template>
<script>
import Header from "../../components/header";
import Title from "../../components/title";
import { ExamStatistics_personlist } from "../../assets/js/api.js";
import fun from "../../assets/js/fun.js";
export default {
  name: "testlist",
  data() {
    return {
      list: [],
      data: {
        userid: this.$route.query.id, //	string	true	普通参数		用户编号
        page: 1, //	string	true	普通参数		页码
        size: 10 //	string	true	普通参数		条数
      },
      total: null
    };
  },
  filters: {
    jige(value) {
      //0不及格1及格null未评分
      switch (value) {
        case 0:
          return "不及格";
        case 1:
          return "及格";
        default:
          return "未评分";
      }
    },
    formate(value) {
      return fun.formatetime(value);
    },
    yuejuan(value) {
      switch (value) {
        case 0:
          return "阅卷中";
        case 1:
          return "已阅卷";
        case 2:
          return "无需阅卷";
      }
    }
  },
  mounted() {
    this.getlist();
  },
  components: {
    Header,
    Title
  },
  methods: {
    changepage(data) {
      this.data.page = data;
      this.getlist();
    },
    changesize(data) {
      this.data.page = 1;
      this.data.size = data;
      this.getlist();
    },
    getlist() {
      ExamStatistics_personlist(this.data).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.list;
          this.total = res.data.data.count;
        }
      });
    },
    topaper(data, data2) {
      if (data2 == 0) {
        this.$router.push("/Recordexampaper?id=" + data);
      } else {
        this.$router.push("/recordpaper?id=" + data);
      }
    }
  }
};
</script>
<style lang="css" scoped>
/* 搜索栏样式------------------------------------------------------------------------------------------- */
.search {
  margin-top: 0.2rem;
  display: flex;
  color: #575e6b;
}
.search .search_item {
  display: flex;
}
.search .search_item .item {
  margin: 0 0.15rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
}
/* 表格栏目样式----------------------------------------------------------------------------------------------*/
.table {
  margin-top: 0.6rem;
  font-size: 0.14rem;
}
table {
  width: 100%;
}
thead tr {
  color: #a4acbf;
}
tbody tr {
  color: #707788;
}
tr {
  height: 0.6rem;
}
/*查看详情button-----------------------------------------------------------------------------------------------------------------*/
button {
  border-radius: 0.2rem;
  border: none;
  margin: 0 0.02rem;
  padding: 0.04rem 0.1rem;
  font-size: 0.14rem;
  outline: none;
}
button.blue {
  color: #25b3f9;
  background: #d3f3fc;
}
button.pri {
  color: #e037ff;
  background: #fadfff;
}
button.orange {
  color: #ff8d13;
  background: #ffe2c4;
}
button.green {
  color: #36cd68;
  background: #cffade;
}
button.red {
  color: #ff3a68;
  background: #ffd6de;
}
</style>


// WEBPACK FOOTER //
// src/pages/statistics/jointestslist.vue